var map = {
	"./g1-1-e-m.png": "34c6",
	"./g1-1-e.png": "4e27",
	"./g1-1-m.png": "ce3a",
	"./g1-1.png": "4ce9",
	"./g1-2-e-m.png": "c6af",
	"./g1-2-e.png": "bf48",
	"./g1-2-m.png": "0190",
	"./g1-2.png": "908b",
	"./g1-3-e-m.png": "9cb6",
	"./g1-3-e.png": "db09",
	"./g1-3-m.png": "f913",
	"./g1-3.png": "4592",
	"./g1-4-e-m.png": "3d13",
	"./g1-4-e.png": "7bc1",
	"./g1-4-m.png": "fa8c",
	"./g1-4.png": "7658",
	"./g1-5-e-m.png": "645c",
	"./g1-5-e.png": "79be",
	"./g1-5-m.png": "32c3",
	"./g1-5.png": "8883",
	"./g1-ActiveDetail-m.png": "74e2",
	"./g1-ActiveDetail.png": "8be2",
	"./g1-ActiveDetaile-m.png": "5c6c",
	"./g1-ActiveDetaile.png": "dc34",
	"./g1-ShortVideo-m.png": "ad1c",
	"./g1-ShortVideo.png": "8fbe",
	"./g1-ShortVideoe-m.png": "2c69",
	"./g1-ShortVideoe.png": "9952"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9b9";